import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(c, t, p, i, m, f) {
  return e(), o("svg", s, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "m13.9 5.426.085.072L20 11.475c.156.155.23.361.22.565l.001.028a.75.75 0 0 1-.426.677l-5.811 5.771a.75.75 0 0 1-1.13-.98l.072-.084 4.664-4.634H4.482a.75.75 0 0 1-.102-1.493l.102-.007h13.232l-4.787-4.756a.75.75 0 0 1-.075-.976l.072-.085a.75.75 0 0 1 .976-.075Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(n, [["render", a]]);
export {
  u as default
};
